/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param attachSize (optional) 附件大小
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param domain (optional) 附件域名
     * @param extension (optional) 附件拓展名
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param link (optional) 附件地址
     * @param name (optional) 附件名称
     * @param originalName (optional) 附件原名
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detailUsingGET(attachSize: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, domain: string | null | undefined, extension: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, link: string | null | undefined, name: string | null | undefined, originalName: string | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfAttach对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/detail?";
        if (attachSize !== undefined)
            url_ += "attachSize=" + encodeURIComponent("" + attachSize) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (originalName !== undefined)
            url_ += "originalName=" + encodeURIComponent("" + originalName) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetailUsingGET(_response);
        });
    }

    protected processDetailUsingGET(response: AxiosResponse): Promise<ROfAttach对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAttach对象.fromJS(resultData200) : new ROfAttach对象();
            return result200;
        }
        return Promise.resolve<ROfAttach对象>(<any>null);
    }

    /**
     * getBizAttachList
     * @param bizId bizId
     * @param bizKey bizKey
     * @return OK
     */
    getBizAttachListUsingGET(bizId: string, bizKey: string): Promise<ROfListOfAttachVO对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/get-attach-list?";
        if (bizId === undefined || bizId === null)
            throw new Error("The parameter 'bizId' must be defined and cannot be null.");
        else
            url_ += "bizId=" + encodeURIComponent("" + bizId) + "&"; 
        if (bizKey === undefined || bizKey === null)
            throw new Error("The parameter 'bizKey' must be defined and cannot be null.");
        else
            url_ += "bizKey=" + encodeURIComponent("" + bizKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBizAttachListUsingGET(_response);
        });
    }

    protected processGetBizAttachListUsingGET(response: AxiosResponse): Promise<ROfListOfAttachVO对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfAttachVO对象.fromJS(resultData200) : new ROfListOfAttachVO对象();
            return result200;
        }
        return Promise.resolve<ROfListOfAttachVO对象>(<any>null);
    }

    /**
     * 分页
     * @param attachSize (optional) 附件大小
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param domain (optional) 附件域名
     * @param extension (optional) 附件拓展名
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param link (optional) 附件地址
     * @param name (optional) 附件名称
     * @param originalName (optional) 附件原名
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    listUsingGET(attachSize: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, domain: string | null | undefined, extension: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, link: string | null | undefined, name: string | null | undefined, originalName: string | null | undefined, size: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfAttach对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/list?";
        if (attachSize !== undefined)
            url_ += "attachSize=" + encodeURIComponent("" + attachSize) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (originalName !== undefined)
            url_ += "originalName=" + encodeURIComponent("" + originalName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListUsingGET(_response);
        });
    }

    protected processListUsingGET(response: AxiosResponse): Promise<ROfIPageOfAttach对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfAttach对象.fromJS(resultData200) : new ROfIPageOfAttach对象();
            return result200;
        }
        return Promise.resolve<ROfIPageOfAttach对象>(<any>null);
    }

    /**
     * 分页
     * @param attachSize (optional) 附件大小
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param domain (optional) 附件域名
     * @param extension (optional) 附件拓展名
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param link (optional) 附件地址
     * @param name (optional) 附件名称
     * @param originalName (optional) 附件原名
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    pageUsingGET(attachSize: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, domain: string | null | undefined, extension: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, link: string | null | undefined, name: string | null | undefined, originalName: string | null | undefined, size: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfAttachVO对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/page?";
        if (attachSize !== undefined)
            url_ += "attachSize=" + encodeURIComponent("" + attachSize) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&"; 
        if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (originalName !== undefined)
            url_ += "originalName=" + encodeURIComponent("" + originalName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageUsingGET(_response);
        });
    }

    protected processPageUsingGET(response: AxiosResponse): Promise<ROfIPageOfAttachVO对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfAttachVO对象.fromJS(resultData200) : new ROfIPageOfAttachVO对象();
            return result200;
        }
        return Promise.resolve<ROfIPageOfAttachVO对象>(<any>null);
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    removeUsingPOST(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveUsingPOST(_response);
        });
    }

    protected processRemoveUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增
     * @param attach attach
     * @return OK
     */
    saveUsingPOST(attach: Attach对象): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attach);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveUsingPOST(_response);
        });
    }

    protected processSaveUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param attach attach
     * @return OK
     */
    submitUsingPOST(attach: Attach对象): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attach);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmitUsingPOST(_response);
        });
    }

    protected processSubmitUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param attach attach
     * @return OK
     */
    updateUsingPOST(attach: Attach对象): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/attach/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attach);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateUsingPOST(_response);
        });
    }

    protected processUpdateUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 配置启用
     * @param id 主键
     * @return OK
     */
    enableUsingPOST(id: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/enable?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEnableUsingPOST(_response);
        });
    }

    protected processEnableUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * copyFile
     * @param destBucketName destBucketName
     * @param destFileName (optional) destFileName
     * @param fileName fileName
     * @return OK
     */
    copyFileUsingPOST(destBucketName: string, destFileName: string | null | undefined, fileName: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/copy-file?";
        if (destBucketName === undefined || destBucketName === null)
            throw new Error("The parameter 'destBucketName' must be defined and cannot be null.");
        else
            url_ += "destBucketName=" + encodeURIComponent("" + destBucketName) + "&"; 
        if (destFileName !== undefined)
            url_ += "destFileName=" + encodeURIComponent("" + destFileName) + "&"; 
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyFileUsingPOST(_response);
        });
    }

    protected processCopyFileUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * getFileContent
     * @param fileName fileName
     * @return OK
     */
    getFileContentUsingGET(fileName: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/file-content?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFileContentUsingGET(_response);
        });
    }

    protected processGetFileContentUsingGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * fileLink
     * @param fileName fileName
     * @return OK
     */
    fileLinkUsingGET(fileName: string): Promise<ROfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/file-link?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFileLinkUsingGET(_response);
        });
    }

    protected processFileLinkUsingGET(response: AxiosResponse): Promise<ROfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfstring.fromJS(resultData200) : new ROfstring();
            return result200;
        }
        return Promise.resolve<ROfstring>(<any>null);
    }

    /**
     * filePath
     * @param fileName fileName
     * @return OK
     */
    filePathUsingGET(fileName: string): Promise<ROfstring> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/file-path?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFilePathUsingGET(_response);
        });
    }

    protected processFilePathUsingGET(response: AxiosResponse): Promise<ROfstring> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfstring.fromJS(resultData200) : new ROfstring();
            return result200;
        }
        return Promise.resolve<ROfstring>(<any>null);
    }

    /**
     * makeBucket
     * @param bucketName bucketName
     * @return OK
     */
    makeBucketUsingPOST(bucketName: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/make-bucket?";
        if (bucketName === undefined || bucketName === null)
            throw new Error("The parameter 'bucketName' must be defined and cannot be null.");
        else
            url_ += "bucketName=" + encodeURIComponent("" + bucketName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMakeBucketUsingPOST(_response);
        });
    }

    protected processMakeBucketUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * putFile
     * @param file file
     * @return OK
     */
    putFileUsingPOST(file: FileParameter): Promise<ROfBladeFile> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/put-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPutFileUsingPOST(_response);
        });
    }

    protected processPutFileUsingPOST(response: AxiosResponse): Promise<ROfBladeFile> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfBladeFile.fromJS(resultData200) : new ROfBladeFile();
            return result200;
        }
        return Promise.resolve<ROfBladeFile>(<any>null);
    }

    /**
     * putFileAttach
     * @param file file
     * @return OK
     */
    putFileAttachUsingPOST(file: FileParameter): Promise<ROfBladeFile> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/put-file-attach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPutFileAttachUsingPOST(_response);
        });
    }

    protected processPutFileAttachUsingPOST(response: AxiosResponse): Promise<ROfBladeFile> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfBladeFile.fromJS(resultData200) : new ROfBladeFile();
            return result200;
        }
        return Promise.resolve<ROfBladeFile>(<any>null);
    }

    /**
     * putFileByName
     * @param file file
     * @param fileName fileName
     * @return OK
     */
    putFileByNameUsingPOST(file: FileParameter, fileName: string): Promise<ROfBladeFile> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/put-file-by-name?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPutFileByNameUsingPOST(_response);
        });
    }

    protected processPutFileByNameUsingPOST(response: AxiosResponse): Promise<ROfBladeFile> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfBladeFile.fromJS(resultData200) : new ROfBladeFile();
            return result200;
        }
        return Promise.resolve<ROfBladeFile>(<any>null);
    }

    /**
     * removeBucket
     * @param bucketName bucketName
     * @return OK
     */
    removeBucketUsingPOST(bucketName: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/remove-bucket?";
        if (bucketName === undefined || bucketName === null)
            throw new Error("The parameter 'bucketName' must be defined and cannot be null.");
        else
            url_ += "bucketName=" + encodeURIComponent("" + bucketName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveBucketUsingPOST(_response);
        });
    }

    protected processRemoveBucketUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * removeFile
     * @param fileName fileName
     * @return OK
     */
    removeFileUsingPOST(fileName: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/remove-file?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveFileUsingPOST(_response);
        });
    }

    protected processRemoveFileUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * removeFiles
     * @param fileNames fileNames
     * @return OK
     */
    removeFilesUsingPOST(fileNames: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/remove-files?";
        if (fileNames === undefined || fileNames === null)
            throw new Error("The parameter 'fileNames' must be defined and cannot be null.");
        else
            url_ += "fileNames=" + encodeURIComponent("" + fileNames) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveFilesUsingPOST(_response);
        });
    }

    protected processRemoveFilesUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * statFile
     * @param fileName fileName
     * @return OK
     */
    statFileUsingGET(fileName: string): Promise<ROfOssFile> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/stat-file?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStatFileUsingGET(_response);
        });
    }

    protected processStatFileUsingGET(response: AxiosResponse): Promise<ROfOssFile> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfOssFile.fromJS(resultData200) : new ROfOssFile();
            return result200;
        }
        return Promise.resolve<ROfOssFile>(<any>null);
    }

    /**
     * statFileViaReverseProxy
     * @param fileName fileName
     * @return OK
     */
    statFileViaReverseProxyUsingGET(fileName: string): Promise<ROfOssFile> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/endpoint/stat-file-via-proxy?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStatFileViaReverseProxyUsingGET(_response);
        });
    }

    protected processStatFileViaReverseProxyUsingGET(response: AxiosResponse): Promise<ROfOssFile> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfOssFile.fromJS(resultData200) : new ROfOssFile();
            return result200;
        }
        return Promise.resolve<ROfOssFile>(<any>null);
    }

    /**
     * sendMeeting
     * @param phones phones
     * @return OK
     */
    sendMeetingUsingPOST(phones: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/sms/endpoint/send-meeting?";
        if (phones === undefined || phones === null)
            throw new Error("The parameter 'phones' must be defined and cannot be null.");
        else
            url_ += "phones=" + encodeURIComponent("" + phones) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendMeetingUsingPOST(_response);
        });
    }

    protected processSendMeetingUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * sendMessage
     * @param params params
     * @param phones phones
     * @return OK
     */
    sendMessageUsingPOST(params: string, phones: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/sms/endpoint/send-message?";
        if (params === undefined || params === null)
            throw new Error("The parameter 'params' must be defined and cannot be null.");
        else
            url_ += "params=" + encodeURIComponent("" + params) + "&"; 
        if (phones === undefined || phones === null)
            throw new Error("The parameter 'phones' must be defined and cannot be null.");
        else
            url_ += "phones=" + encodeURIComponent("" + phones) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendMessageUsingPOST(_response);
        });
    }

    protected processSendMessageUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * sendNotice
     * @param phones phones
     * @return OK
     */
    sendNoticeUsingPOST(phones: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/sms/endpoint/send-notice?";
        if (phones === undefined || phones === null)
            throw new Error("The parameter 'phones' must be defined and cannot be null.");
        else
            url_ += "phones=" + encodeURIComponent("" + phones) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendNoticeUsingPOST(_response);
        });
    }

    protected processSendNoticeUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * sendOrder
     * @param phones phones
     * @return OK
     */
    sendOrderUsingPOST(phones: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/sms/endpoint/send-order?";
        if (phones === undefined || phones === null)
            throw new Error("The parameter 'phones' must be defined and cannot be null.");
        else
            url_ += "phones=" + encodeURIComponent("" + phones) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendOrderUsingPOST(_response);
        });
    }

    protected processSendOrderUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * sendValidate
     * @param phone phone
     * @return OK
     */
    sendValidateUsingPOST(phone: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/sms/endpoint/send-validate?";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendValidateUsingPOST(_response);
        });
    }

    protected processSendValidateUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * validateMessage
     * @param id (optional) 
     * @param phone (optional) 
     * @param success (optional) 
     * @param value (optional) 
     * @return OK
     */
    validateMessageUsingPOST(id: string | null | undefined, phone: string | null | undefined, success: boolean | null | undefined, value: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/sms/endpoint/validate-message?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&"; 
        if (success !== undefined)
            url_ += "success=" + encodeURIComponent("" + success) + "&"; 
        if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processValidateMessageUsingPOST(_response);
        });
    }

    protected processValidateMessageUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class DetailUsingGETServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 详情
     * @param accessKey (optional) accessKey
     * @param appId (optional) 应用ID
     * @param bucketName (optional) 空间名
     * @param category (optional) 所属分类
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param endpoint (optional) 资源地址
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param ossCode (optional) 资源编号
     * @param region (optional) 地域简称
     * @param remark (optional) 备注
     * @param secretKey (optional) secretKey
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    1(accessKey: string | null | undefined, appId: string | null | undefined, bucketName: string | null | undefined, category: number | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, endpoint: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, ossCode: string | null | undefined, region: string | null | undefined, remark: string | null | undefined, secretKey: string | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfOssVO对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/detail?";
        if (accessKey !== undefined)
            url_ += "accessKey=" + encodeURIComponent("" + accessKey) + "&"; 
        if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (bucketName !== undefined)
            url_ += "bucketName=" + encodeURIComponent("" + bucketName) + "&"; 
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (endpoint !== undefined)
            url_ += "endpoint=" + encodeURIComponent("" + endpoint) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (ossCode !== undefined)
            url_ += "ossCode=" + encodeURIComponent("" + ossCode) + "&"; 
        if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (secretKey !== undefined)
            url_ += "secretKey=" + encodeURIComponent("" + secretKey) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ROfOssVO对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfOssVO对象.fromJS(resultData200) : new ROfOssVO对象();
            return result200;
        }
        return Promise.resolve<ROfOssVO对象>(<any>null);
    }
}

export class ListUsingGETServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 分页
     * @param accessKey (optional) accessKey
     * @param appId (optional) 应用ID
     * @param bucketName (optional) 空间名
     * @param category (optional) 所属分类
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param endpoint (optional) 资源地址
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param ossCode (optional) 资源编号
     * @param region (optional) 地域简称
     * @param remark (optional) 备注
     * @param secretKey (optional) secretKey
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    1(accessKey: string | null | undefined, appId: string | null | undefined, bucketName: string | null | undefined, category: number | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, endpoint: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, ossCode: string | null | undefined, region: string | null | undefined, remark: string | null | undefined, secretKey: string | null | undefined, size: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfOssVO对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/list?";
        if (accessKey !== undefined)
            url_ += "accessKey=" + encodeURIComponent("" + accessKey) + "&"; 
        if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (bucketName !== undefined)
            url_ += "bucketName=" + encodeURIComponent("" + bucketName) + "&"; 
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (endpoint !== undefined)
            url_ += "endpoint=" + encodeURIComponent("" + endpoint) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (ossCode !== undefined)
            url_ += "ossCode=" + encodeURIComponent("" + ossCode) + "&"; 
        if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (secretKey !== undefined)
            url_ += "secretKey=" + encodeURIComponent("" + secretKey) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ROfIPageOfOssVO对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfOssVO对象.fromJS(resultData200) : new ROfIPageOfOssVO对象();
            return result200;
        }
        return Promise.resolve<ROfIPageOfOssVO对象>(<any>null);
    }
}

export class PageUsingGETServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 分页
     * @param accessKey (optional) accessKey
     * @param appId (optional) 应用ID
     * @param bucketName (optional) 空间名
     * @param category (optional) 所属分类
     * @param categoryName (optional) 
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param current (optional) 当前页
     * @param endpoint (optional) 资源地址
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param ossCode (optional) 资源编号
     * @param region (optional) 地域简称
     * @param remark (optional) 备注
     * @param secretKey (optional) secretKey
     * @param size (optional) 每页的数量
     * @param status (optional) 业务状态
     * @param statusName (optional) 
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    1(accessKey: string | null | undefined, appId: string | null | undefined, bucketName: string | null | undefined, category: number | null | undefined, categoryName: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, current: number | null | undefined, endpoint: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, ossCode: string | null | undefined, region: string | null | undefined, remark: string | null | undefined, secretKey: string | null | undefined, size: number | null | undefined, status: number | null | undefined, statusName: string | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfIPageOfOssVO对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/page?";
        if (accessKey !== undefined)
            url_ += "accessKey=" + encodeURIComponent("" + accessKey) + "&"; 
        if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (bucketName !== undefined)
            url_ += "bucketName=" + encodeURIComponent("" + bucketName) + "&"; 
        if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (categoryName !== undefined)
            url_ += "categoryName=" + encodeURIComponent("" + categoryName) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (endpoint !== undefined)
            url_ += "endpoint=" + encodeURIComponent("" + endpoint) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (ossCode !== undefined)
            url_ += "ossCode=" + encodeURIComponent("" + ossCode) + "&"; 
        if (region !== undefined)
            url_ += "region=" + encodeURIComponent("" + region) + "&"; 
        if (remark !== undefined)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        if (secretKey !== undefined)
            url_ += "secretKey=" + encodeURIComponent("" + secretKey) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (statusName !== undefined)
            url_ += "statusName=" + encodeURIComponent("" + statusName) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ROfIPageOfOssVO对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfOssVO对象.fromJS(resultData200) : new ROfIPageOfOssVO对象();
            return result200;
        }
        return Promise.resolve<ROfIPageOfOssVO对象>(<any>null);
    }
}

export class RemoveUsingPOSTServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 逻辑删除
     * @param ids 主键集合
     * @return OK
     */
    1(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class SaveUsingPOSTServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增
     * @param oss oss
     * @return OK
     */
    1(oss: Oss对象): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(oss);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class SubmitUsingPOSTServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增或修改
     * @param oss oss
     * @return OK
     */
    1(oss: Oss对象): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(oss);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class UpdateUsingPOSTServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 修改
     * @param oss oss
     * @return OK
     */
    1(oss: Oss对象): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/blade-resource')+ "/oss/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(oss);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

/** 附件表 */
export class AttachVO对象 implements IAttachVO对象 {
    /** 附件大小 */
    attachSize!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 附件域名 */
    domain!: string | undefined;
    /** 附件拓展名 */
    extension!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 附件地址 */
    link!: string | undefined;
    /** 附件名称 */
    name!: string | undefined;
    /** 附件原名 */
    originalName!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IAttachVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachSize = data["attachSize"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.domain = data["domain"];
            this.extension = data["extension"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.link = data["link"];
            this.name = data["name"];
            this.originalName = data["originalName"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): AttachVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new AttachVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachSize"] = this.attachSize;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["domain"] = this.domain;
        data["extension"] = this.extension;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["link"] = this.link;
        data["name"] = this.name;
        data["originalName"] = this.originalName;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 附件表 */
export interface IAttachVO对象 {
    /** 附件大小 */
    attachSize: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 附件域名 */
    domain: string | undefined;
    /** 附件拓展名 */
    extension: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 附件地址 */
    link: string | undefined;
    /** 附件名称 */
    name: string | undefined;
    /** 附件原名 */
    originalName: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** 附件表 */
export class Attach对象 implements IAttach对象 {
    /** 附件大小 */
    attachSize!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 附件域名 */
    domain!: string | undefined;
    /** 附件拓展名 */
    extension!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 附件地址 */
    link!: string | undefined;
    /** 附件名称 */
    name!: string | undefined;
    /** 附件原名 */
    originalName!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IAttach对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachSize = data["attachSize"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.domain = data["domain"];
            this.extension = data["extension"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.link = data["link"];
            this.name = data["name"];
            this.originalName = data["originalName"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Attach对象 {
        data = typeof data === 'object' ? data : {};
        let result = new Attach对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachSize"] = this.attachSize;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["domain"] = this.domain;
        data["extension"] = this.extension;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["link"] = this.link;
        data["name"] = this.name;
        data["originalName"] = this.originalName;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 附件表 */
export interface IAttach对象 {
    /** 附件大小 */
    attachSize: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 附件域名 */
    domain: string | undefined;
    /** 附件拓展名 */
    extension: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 附件地址 */
    link: string | undefined;
    /** 附件名称 */
    name: string | undefined;
    /** 附件原名 */
    originalName: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class BladeFile implements IBladeFile {
    attachId!: string | undefined;
    domain!: string | undefined;
    link!: string | undefined;
    name!: string | undefined;
    originalName!: string | undefined;

    constructor(data?: IBladeFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachId = data["attachId"];
            this.domain = data["domain"];
            this.link = data["link"];
            this.name = data["name"];
            this.originalName = data["originalName"];
        }
    }

    static fromJS(data: any): BladeFile {
        data = typeof data === 'object' ? data : {};
        let result = new BladeFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachId"] = this.attachId;
        data["domain"] = this.domain;
        data["link"] = this.link;
        data["name"] = this.name;
        data["originalName"] = this.originalName;
        return data; 
    }
}

export interface IBladeFile {
    attachId: string | undefined;
    domain: string | undefined;
    link: string | undefined;
    name: string | undefined;
    originalName: string | undefined;
}

export class IPageOfAttachVO对象 implements IIPageOfAttachVO对象 {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AttachVO对象[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAttachVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AttachVO对象.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAttachVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAttachVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAttachVO对象 {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AttachVO对象[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAttach对象 implements IIPageOfAttach对象 {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: Attach对象[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAttach对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(Attach对象.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAttach对象 {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAttach对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAttach对象 {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: Attach对象[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfOssVO对象 implements IIPageOfOssVO对象 {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: OssVO对象[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfOssVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(OssVO对象.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfOssVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfOssVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfOssVO对象 {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: OssVO对象[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class OssFile implements IOssFile {
    contentType!: string | undefined;
    hash!: string | undefined;
    length!: string | undefined;
    link!: string | undefined;
    name!: string | undefined;
    putTime!: Date | undefined;

    constructor(data?: IOssFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.hash = data["hash"];
            this.length = data["length"];
            this.link = data["link"];
            this.name = data["name"];
            this.putTime = data["putTime"] ? new Date(data["putTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OssFile {
        data = typeof data === 'object' ? data : {};
        let result = new OssFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["hash"] = this.hash;
        data["length"] = this.length;
        data["link"] = this.link;
        data["name"] = this.name;
        data["putTime"] = this.putTime ? this.putTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IOssFile {
    contentType: string | undefined;
    hash: string | undefined;
    length: string | undefined;
    link: string | undefined;
    name: string | undefined;
    putTime: Date | undefined;
}

/** 对象存储表 */
export class OssVO对象 implements IOssVO对象 {
    /** accessKey */
    accessKey!: string | undefined;
    /** 应用ID */
    appId!: string | undefined;
    /** 空间名 */
    bucketName!: string | undefined;
    /** 所属分类 */
    category!: number | undefined;
    categoryName!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 资源地址 */
    endpoint!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 资源编号 */
    ossCode!: string | undefined;
    /** 地域简称 */
    region!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** secretKey */
    secretKey!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    statusName!: string | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IOssVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessKey = data["accessKey"];
            this.appId = data["appId"];
            this.bucketName = data["bucketName"];
            this.category = data["category"];
            this.categoryName = data["categoryName"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.endpoint = data["endpoint"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.ossCode = data["ossCode"];
            this.region = data["region"];
            this.remark = data["remark"];
            this.secretKey = data["secretKey"];
            this.status = data["status"];
            this.statusName = data["statusName"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): OssVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new OssVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["appId"] = this.appId;
        data["bucketName"] = this.bucketName;
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["endpoint"] = this.endpoint;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["ossCode"] = this.ossCode;
        data["region"] = this.region;
        data["remark"] = this.remark;
        data["secretKey"] = this.secretKey;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 对象存储表 */
export interface IOssVO对象 {
    /** accessKey */
    accessKey: string | undefined;
    /** 应用ID */
    appId: string | undefined;
    /** 空间名 */
    bucketName: string | undefined;
    /** 所属分类 */
    category: number | undefined;
    categoryName: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 资源地址 */
    endpoint: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 资源编号 */
    ossCode: string | undefined;
    /** 地域简称 */
    region: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** secretKey */
    secretKey: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    statusName: string | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** Oss对象 */
export class Oss对象 implements IOss对象 {
    /** accessKey */
    accessKey!: string | undefined;
    /** 应用ID */
    appId!: string | undefined;
    /** 空间名 */
    bucketName!: string | undefined;
    /** 所属分类 */
    category!: number | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 资源地址 */
    endpoint!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 资源编号 */
    ossCode!: string | undefined;
    /** 地域简称 */
    region!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** secretKey */
    secretKey!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IOss对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessKey = data["accessKey"];
            this.appId = data["appId"];
            this.bucketName = data["bucketName"];
            this.category = data["category"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.endpoint = data["endpoint"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.ossCode = data["ossCode"];
            this.region = data["region"];
            this.remark = data["remark"];
            this.secretKey = data["secretKey"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Oss对象 {
        data = typeof data === 'object' ? data : {};
        let result = new Oss对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessKey"] = this.accessKey;
        data["appId"] = this.appId;
        data["bucketName"] = this.bucketName;
        data["category"] = this.category;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["endpoint"] = this.endpoint;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["ossCode"] = this.ossCode;
        data["region"] = this.region;
        data["remark"] = this.remark;
        data["secretKey"] = this.secretKey;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** Oss对象 */
export interface IOss对象 {
    /** accessKey */
    accessKey: string | undefined;
    /** 应用ID */
    appId: string | undefined;
    /** 空间名 */
    bucketName: string | undefined;
    /** 所属分类 */
    category: number | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 资源地址 */
    endpoint: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 资源编号 */
    ossCode: string | undefined;
    /** 地域简称 */
    region: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** secretKey */
    secretKey: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfAttach对象 implements IROfAttach对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Attach对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAttach对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? Attach对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAttach对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAttach对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAttach对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Attach对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfBladeFile implements IROfBladeFile {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: BladeFile | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfBladeFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? BladeFile.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfBladeFile {
        data = typeof data === 'object' ? data : {};
        let result = new ROfBladeFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfBladeFile {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: BladeFile | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfAttachVO对象 implements IROfIPageOfAttachVO对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfAttachVO对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfAttachVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfAttachVO对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfAttachVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfAttachVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfAttachVO对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfAttachVO对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfAttach对象 implements IROfIPageOfAttach对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfAttach对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfAttach对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfAttach对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfAttach对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfAttach对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfAttach对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfAttach对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfOssVO对象 implements IROfIPageOfOssVO对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfOssVO对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfOssVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfOssVO对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfOssVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfOssVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfOssVO对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfOssVO对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfAttachVO对象 implements IROfListOfAttachVO对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AttachVO对象[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfAttachVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(AttachVO对象.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfAttachVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfAttachVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfAttachVO对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AttachVO对象[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfOssFile implements IROfOssFile {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: OssFile | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfOssFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? OssFile.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfOssFile {
        data = typeof data === 'object' ? data : {};
        let result = new ROfOssFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfOssFile {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: OssFile | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfOssVO对象 implements IROfOssVO对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: OssVO对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfOssVO对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? OssVO对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfOssVO对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfOssVO对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfOssVO对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: OssVO对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfstring implements IROfstring {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: string | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfstring {
        data = typeof data === 'object' ? data : {};
        let result = new ROfstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfstring {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: string | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}